import React, { useMemo, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { Box, Button, Paper, Typography } from "@mui/material";

import PivieSurveyForm from "./PivieSurvey"; 
import pivieSurveyJson from "./survey_templates/pivieSurvey.json"; // your uploaded survey
import { request_config, service_url } from "./config";

// Mint green close to SurveyJS mint theme; tweak if you want exact match
const MINT = "#5ac69f";

function extractQuestionNames(surveyJson) {
  const names = [];

  const walkElements = (elements = []) => {
    elements.forEach((el) => {
      if (el.name) names.push(el.name);

      // Panels / dynamic panels can nest elements
      if (el.elements) walkElements(el.elements);
      if (el.templateElements) walkElements(el.templateElements);

      // Some question types include nested items
      if (el.questions) walkElements(el.questions);
    });
  };

  (surveyJson.pages || []).forEach((p) => walkElements(p.elements));
  return names;
}

function flattenPayload(payload, questionNames) {
  const row = {};
  questionNames.forEach((q) => {
    const val = payload?.[q];

    // normalize arrays/objects to readable strings
    if (Array.isArray(val)) row[q] = val.join(", ");
    else if (val && typeof val === "object") row[q] = JSON.stringify(val);
    else row[q] = val ?? "";
  });
  return row;
}

export default function PivieHome() {
  const [showSurvey, setShowSurvey] = useState(false);
  const questionNames = useMemo(
    () => extractQuestionNames(pivieSurveyJson),
    []
  );

  const handleDownload = async () => {
    
      // TODO: replace with your real endpoint
      // Expected response: [{ UserName, SubmissionDateTime, SubmissionID, payload }, ...]
      console.log(sessionStorage.getItem('site_id'))
      axios.post(service_url+"/download_pivie_data",{"care_site_id":sessionStorage.getItem('site_id')}, request_config)
      .then((response)=>{
        const data = response.data['output']
          const rows = (data || []).map((r) => ({
              UserName: r.UserName ?? "",
              SubmissionDateTime: r.SubmissionDateTime ?? "",
              ...flattenPayload(r.payload, questionNames),
            }));
            // Column order: fixed columns then question columns
            const headers = ["UserName", "SubmissionDateTime", ...questionNames];

            const ws = XLSX.utils.json_to_sheet(rows, { header: headers });
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "PivieData");

            XLSX.writeFile(wb, `pivie_data_${Date.now()}.xlsx`);

      },(error)=>{
        console.error("Download failed:", error);
      alert("Download failed. Please try again.");
      });      
  };

  if (showSurvey) {
    return <PivieSurveyForm />;
  }

  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          maxWidth: 900,
          p: 6,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 4,
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          PIVIE Prevention Data
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 3,
            width: "100%",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            size="large"
            onClick={() => setShowSurvey(true)}
            sx={{
              backgroundColor: MINT,
              color: "white",
              fontWeight: 700,
              px: 5,
              py: 2.5,
              fontSize: "1.2rem",
              borderRadius: 3,
              width: { xs: "100%", sm: "auto" },
              "&:hover": { backgroundColor: "#7ad9c3" },
            }}
          >
            Submit Pivie Data
          </Button>

          <Button
            variant="contained"
            size="large"
            onClick={handleDownload}
            sx={{
              backgroundColor: MINT,
              color: "white",
              fontWeight: 700,
              px: 5,
              py: 2.5,
              fontSize: "1.2rem",
              borderRadius: 3,
              width: { xs: "100%", sm: "auto" },
              "&:hover": { backgroundColor: "#7ad9c3" },
            }}
          >
            Download Pivie Data
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
